import { render, staticRenderFns } from "./TopicFormPanelDescription.vue?vue&type=template&id=0d8dabe8"
import script from "./TopicFormPanelDescription.vue?vue&type=script&lang=ts"
export * from "./TopicFormPanelDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports